"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConditionalToken = void 0;
const transformations_1 = require("../../transformations");
const createConditionalToken = (data) => {
    return `{# cond-token:1 ${(0, transformations_1.dataToBase64)(data)} #}`;
};
exports.createConditionalToken = createConditionalToken;
//# sourceMappingURL=create-conditional-token.js.map